(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["softspace-design"] && !Shopify.designMode) return;
  try {
    (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const selector = '[data-softspace-reveal]';
    let observer;
    let fallback;
    const reveal = (element) => {
      element.classList.remove('softspace-reveal-pending');
      element.classList.add('softspace-reveal-visible');
      observer?.unobserve(element);
    };
    const showAll = () => {
      document.querySelectorAll(selector).forEach((element) => {
        element.classList.remove('softspace-reveal-pending', 'softspace-reveal-visible');
      });
      observer?.disconnect();
      clearTimeout(fallback);
    };
    const setup = () => {
      showAll();
      if (motion.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
      document.querySelector('#MainContent[data-template="index"] > .shopify-section:last-child:not(:has(.hero))')?.setAttribute('data-softspace-reveal', '');
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) reveal(entry.target); });
      }, { threshold: 0, rootMargin: '0px 0px 24px 0px' });
      document.querySelectorAll(selector).forEach((element) => {
        if (element.getBoundingClientRect().top <= window.innerHeight) return;
        element.classList.add('softspace-reveal-pending');
        observer.observe(element);
      });
      fallback = setTimeout(showAll, 12000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
    else setup();
    motion.addEventListener('change', setup);
    document.addEventListener('shopify:section:load', setup);
    document.addEventListener('focusin', (event) => {
      const section = event.target.closest?.(selector);
      if (section) reveal(section);
    });
    window.addEventListener('pageshow', (event) => { if (event.persisted) showAll(); });
  })();
  } catch(e) { console.error(e); }
})();

})();
